import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTENER PROVEEDORES CAI
export const getProveedorCAI = async () => {
  const respuesta = await PrivateInterceptor(`Compras/ProveedorCAI`, "GET");
  return respuesta;
};

// OBTIENER DETALLE DE UNA REQUISA
export const getProveedorCAIporVendor = async (IdVendor) => {
  const result = await PrivateInterceptor('Compras/ProveedorCAI/ProveedorCAIporVendor', 'POST', { IdVendor })
  return result;
}

// GUARDAR PROVEEDOR CAI
export const GuardarProveedorCAI = (Encabezado) => {
  const respuesta = PrivateInterceptor("Compras/ProveedorCAI/GuardarProveedorCAI", "POST", {Encabezado});
  return respuesta;
};

// GUARDAR PROVEEDOR CAI
export const EditarProveedorCAI = (Encabezado) => {
  const respuesta = PrivateInterceptor("Compras/ProveedorCAI/EditarProveedoresCAI", "POST", {Encabezado});
  return respuesta;
};

export const getCAIProveedor = async (IdProveedorCAI) =>{
  const result = await PrivateInterceptor(`Compras/ProveedorCAI/informacionCAI/${IdProveedorCAI}`, 'GET');
  return result;
}

// OBTENER TIPOS CAI ACTIVOS
export const getTiposCAI = async () => {
  const result = await PrivateInterceptor("Compras/ProveedorCAI/TiposCAIActivos", "GET");
  return result;
};

// CAMBIAR PROVEEDOR ASIGNADO AL CAI
export const CambiarProveedorCAI = async (Encabezado) => {
  const result = await PrivateInterceptor("Compras/ProveedorCAI/CambiarProveedorCAI", "POST", { Encabezado } );
  return result;
};